export default __webpack_public_path__ + "static/media/tie_11.dbc2ae18.mp3";